module.exports = __webpack_public_path__ + "img/game06.5ad124c5.png";